/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { IStorageAdapter } from '@tivocorp/data-domain-lib';

export class LocalStorage implements IStorageAdapter {
    // eslint-disable-next-line class-methods-use-this
    public getItem(key: string): string | null {
        const data = localStorage.getItem(key);
        if (!data) return null;
        const jsonData = JSON.parse(data);
        return jsonData[key];
    }

    // eslint-disable-next-line class-methods-use-this
    public setItem(key: string, value: string): void {
        const data = {};
        data[key] = value;
        localStorage.setItem(key, JSON.stringify(data));
    }

    // eslint-disable-next-line class-methods-use-this
    public removeItem(key: string): void {
        localStorage.removeItem(key);
    }

    // eslint-disable-next-line class-methods-use-this
    public clear(): void {
        localStorage.clear();
    }
}
